// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sx-1";
export var stateContainer = "_sx-0";